import * as S from "./styles";

const TabSelector = ({
  showCalendar,
  currentTab,
  setCurrentTab,
  isSponsor,
}) => {
  return (
    <S.Wrapper>
      {showCalendar && (
        <S.Tab
          onClick={() => setCurrentTab("calendar")}
          active={currentTab === "calendar"}
        >
          {/* Renomeada de "Calendário" (D28, 29/08/2026). */}
          <span>Cronograma</span>
          <S.Indicator active={currentTab === "calendar"} />
        </S.Tab>
      )}

      <S.Tab
        onClick={() => setCurrentTab("list")}
        active={currentTab === "list"}
      >
        {/* Para o patrocinador esta aba é a carteira de projetos APORTADOS, e o
            rótulo diz isso — "Meus Projetos" sugeria posse de projeto, que é do
            proponente. O nome coincide de propósito com o KPI "Projetos
            Patrocinados", que leva justamente para cá.

            Para o proponente virou "Projetos Cadastrados" em 18/08/2026, também
            casando com o KPI homônimo. ⚠️ O link do MENU do header segue "Meus
            Projetos" para os dois perfis. */}
        <span>
          {isSponsor ? "Projetos Patrocinados" : "Projetos Cadastrados"}
        </span>
        <S.Indicator active={currentTab === "list"} />
      </S.Tab>

      {/* Aba exclusiva do PROPONENTE (18/08/2026): os projetos dele que já
          receberam aporte. Para o patrocinador não existe — a aba "list" dele
          já é a carteira de aportados. */}
      {!isSponsor && (
        <S.Tab
          onClick={() => setCurrentTab("contributed")}
          active={currentTab === "contributed"}
        >
          <span>Projetos Aportados</span>
          <S.Indicator active={currentTab === "contributed"} />
        </S.Tab>
      )}

      {isSponsor && (
        <S.Tab
          onClick={() => setCurrentTab("selectives")}
          active={currentTab === "selectives"}
        >
          <span>Seletivas</span>
          <S.Indicator active={currentTab === "selectives"} />
        </S.Tab>
      )}
    </S.Wrapper>
  );
};

export default TabSelector;
